"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdDraftUpdateRequestToJSON = exports.AdDraftUpdateRequestFromJSONTyped = exports.AdDraftUpdateRequestFromJSON = exports.instanceOfAdDraftUpdateRequest = void 0;
var runtime_1 = require("../runtime");
var AdAssets_1 = require("./AdAssets");
var AdCallToActionRequest_1 = require("./AdCallToActionRequest");
var AdThirdPartyTracking_1 = require("./AdThirdPartyTracking");
var Placement_1 = require("./Placement");
/**
 * Check if a given object implements the AdDraftUpdateRequest interface.
 */
function instanceOfAdDraftUpdateRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdDraftUpdateRequest = instanceOfAdDraftUpdateRequest;
function AdDraftUpdateRequestFromJSON(json) {
    return AdDraftUpdateRequestFromJSONTyped(json, false);
}
exports.AdDraftUpdateRequestFromJSON = AdDraftUpdateRequestFromJSON;
function AdDraftUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'advertiserName': !(0, runtime_1.exists)(json, 'advertiser_name') ? undefined : json['advertiser_name'],
        'assets': !(0, runtime_1.exists)(json, 'assets') ? undefined : (0, AdAssets_1.AdAssetsFromJSON)(json['assets']),
        'tagline': !(0, runtime_1.exists)(json, 'tagline') ? undefined : json['tagline'],
        'thirdPartyTracking': !(0, runtime_1.exists)(json, 'third_party_tracking') ? undefined : (json['third_party_tracking'].map(AdThirdPartyTracking_1.AdThirdPartyTrackingFromJSON)),
        'callToAction': !(0, runtime_1.exists)(json, 'call_to_action') ? undefined : (0, AdCallToActionRequest_1.AdCallToActionRequestFromJSON)(json['call_to_action']),
        'placements': !(0, runtime_1.exists)(json, 'placements') ? undefined : (json['placements'].map(Placement_1.PlacementFromJSON)),
        'dvClientCode': !(0, runtime_1.exists)(json, 'dv_client_code') ? undefined : json['dv_client_code'],
    };
}
exports.AdDraftUpdateRequestFromJSONTyped = AdDraftUpdateRequestFromJSONTyped;
function AdDraftUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'advertiser_name': value.advertiserName,
        'assets': (0, AdAssets_1.AdAssetsToJSON)(value.assets),
        'tagline': value.tagline,
        'third_party_tracking': value.thirdPartyTracking === undefined ? undefined : (value.thirdPartyTracking.map(AdThirdPartyTracking_1.AdThirdPartyTrackingToJSON)),
        'call_to_action': (0, AdCallToActionRequest_1.AdCallToActionRequestToJSON)(value.callToAction),
        'placements': value.placements === undefined ? undefined : (value.placements.map(Placement_1.PlacementToJSON)),
        'dv_client_code': value.dvClientCode,
    };
}
exports.AdDraftUpdateRequestToJSON = AdDraftUpdateRequestToJSON;
